/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ServiceProperties } from "./ServiceProperties";
import {
  ServicePropertiesFromJSON,
  ServicePropertiesFromJSONTyped,
  ServicePropertiesToJSON,
  ServicePropertiesToJSONTyped,
} from "./ServiceProperties";

/**
 *
 * @export
 * @interface ServicePropertiesAndServiceAreaDescription
 */
export interface ServicePropertiesAndServiceAreaDescription {
  /**
   *
   * @type {ServiceProperties}
   * @memberof ServicePropertiesAndServiceAreaDescription
   */
  serviceProperties: ServiceProperties;
  /**
   *
   * @type {string}
   * @memberof ServicePropertiesAndServiceAreaDescription
   */
  serviceAreaDescription: string;
}

/**
 * Check if a given object implements the ServicePropertiesAndServiceAreaDescription interface.
 */
export function instanceOfServicePropertiesAndServiceAreaDescription(
  value: object,
): value is ServicePropertiesAndServiceAreaDescription {
  if (
    !("serviceProperties" in value) ||
    value["serviceProperties"] === undefined
  )
    return false;
  if (
    !("serviceAreaDescription" in value) ||
    value["serviceAreaDescription"] === undefined
  )
    return false;
  return true;
}

export function ServicePropertiesAndServiceAreaDescriptionFromJSON(
  json: any,
): ServicePropertiesAndServiceAreaDescription {
  return ServicePropertiesAndServiceAreaDescriptionFromJSONTyped(json, false);
}

export function ServicePropertiesAndServiceAreaDescriptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServicePropertiesAndServiceAreaDescription {
  if (json == null) {
    return json;
  }
  return {
    serviceProperties: ServicePropertiesFromJSON(json["serviceProperties"]),
    serviceAreaDescription: json["serviceAreaDescription"],
  };
}

export function ServicePropertiesAndServiceAreaDescriptionToJSON(
  json: any,
): ServicePropertiesAndServiceAreaDescription {
  return ServicePropertiesAndServiceAreaDescriptionToJSONTyped(json, false);
}

export function ServicePropertiesAndServiceAreaDescriptionToJSONTyped(
  value?: ServicePropertiesAndServiceAreaDescription | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    serviceProperties: ServicePropertiesToJSON(value["serviceProperties"]),
    serviceAreaDescription: value["serviceAreaDescription"],
  };
}
